// Múi giờ IANA của MÁY đang dùng (vd 'America/Toronto') — gửi kèm khi tạo workspace để máy chủ đặt
// `company_timezone` đúng chỗ khách đang ngồi. Trình duyệt cổ / chặn Intl ⇒ undefined: máy chủ tự rơi
// về múi dự phòng, không bao giờ vì thế mà hỏng lượt đăng ký.
export function deviceTimezone() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof tz === 'string' && tz ? tz : undefined;
  } catch {
    return undefined;
  }
}

// Trình duyệt báo múi giờ lên hồ sơ — cùng luật app (lib/core/auth/timezone_sync.dart, sếp chốt 02/09/2026):
// máy khác hồ sơ thì tự đổi, im lặng; hồ sơ trống thì KHÔNG đổi ngầm. Thiếu bước này thì chủ workspace chỉ dùng web
// (như khách tự đăng ký 09/10/2026) không bao giờ kích được đường nhận múi giờ workspace của máy chủ
// (PUT /auth/me/timezone › companyTimezoneAdoption) — workspace kẹt giờ VN gieo sẵn, hạn 17:00 báo «trễ 5 giờ».
// Một lần mỗi phiên tab; lỗi nuốt (404 = hệ chưa có cửa này).
const DONG_NGHIA = { 'Asia/Saigon': 'Asia/Ho_Chi_Minh' };
const chuan = (tz) => DONG_NGHIA[tz] || tz;

export async function syncDeviceTimezone(client, profileTz) {
  const may = deviceTimezone();
  if (!may || !profileTz || chuan(may) === chuan(profileTz)) return null;
  const KHOA = 'sc.tzSynced';
  try {
    if (sessionStorage.getItem(KHOA) === may) return null;
    sessionStorage.setItem(KHOA, may);
  } catch { /* storage bị chặn: vẫn gửi, máy chủ tự bỏ qua khi trùng */ }
  try {
    const r = await client.put('/auth/me/timezone', { timezone: may });
    return r?.data?.data || null;
  } catch {
    return null;
  }
}
